//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    reportsDocuments: {
      type: Array,
      default () {
        return []
      }
    },
    reportRoadsFiles: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      selectedReportId: null,
      selectedReportFiles: null,
      reportRoadsFilesLocal: []
    }
  },
  computed: {
    dialogOpened: function () {
      return this.opened
    }
  },
  watch: {
    selectedReportId: function () {
      for (const reportDocuments of this.reportsDocuments) {
        if (reportDocuments.id === this.selectedReportId) {
          this.selectedReportFiles = reportDocuments.reportFiles
          break
        }
      }
    },
    opened: function (result) {
      if (result) {
        this.reportRoadsFilesLocal = [...this.reportRoadsFiles]
        this.selectedReportId = this.reportsDocuments[this.reportsDocuments.length - 1].id
      }
    }
  },
  methods: {
    onConfirm: function () {
      this.$emit('confirm', this.reportRoadsFilesLocal)
    },
    onCancel: function () {
      this.$emit('cancel')
    },
    downloadFileByURI: function (uri, name) {
      const link = document.createElement('a')
      link.setAttribute('download', name)
      link.href = uri
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    selectOrDeleteFile: function (file) {
      const deleteFile = this.reportRoadsFilesLocal
        .map(reportRoadsFile => reportRoadsFile.id)
        .includes(file.id)

      if (!deleteFile) {
        this.reportRoadsFilesLocal.push(file)
      } else {
        this.reportRoadsFilesLocal = this.reportRoadsFilesLocal
          .filter(img => img.id !== file.id)
      }
    }
  }
}

